import { c as _c } from "react/compiler-runtime";
import { Button } from "@heroui/react";
import { ButtonOverride } from "./ButtonOverride";
import { cn } from "@/util/cn";
import { InlineIcon } from "@iconify/react/dist/iconify.js";
import { projTheme } from "@/constants/project-specific/theme";
import type { ColorsThemeType } from "@/constants/project-specific/theme/types";
import { Calculator } from "lucide-react";
interface IconButtonProps {
  icon: string;
  hover?: string;
  active?: string;
  cursor?: string;
  className?: string;
  onClick?: () => void;
  color?: ColorsThemeType;
  disabled?: boolean;
}
export default function IconButton(t0) {
  const $ = _c(10);
  const {
    className,
    hover,
    active,
    cursor,
    color: t1,
    onClick,
    disabled: t2
  } = t0;
  const color = t1 === undefined ? "secondary" : t1;
  const disabled = t2 === undefined ? false : t2;
  const t3 = `text-lg hover:${hover || projTheme.iconButton?.defaultHover} active:${active || projTheme.iconButton?.defaultActive} hover:${cursor || projTheme.iconButton?.defaultCursor || "cursor-pointer"}`;
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = cn(t3, className);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t4) {
    t5 = <Calculator width={15} height={15} className={t4} />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== color || $[6] !== disabled || $[7] !== onClick || $[8] !== t5) {
    t6 = <Button size="sm" isIconOnly={true} variant="light" color={color} radius="full" className="inline-flex h-[15px] w-[15px] m-0 p-0 pb-[1px] place-self-center" disabled={disabled} onPress={onClick} startContent={t5} />;
    $[5] = color;
    $[6] = disabled;
    $[7] = onClick;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}